import React, { useState } from "react";
import Snackbar from "@mui/material/Snackbar";

import { generateKioskDeviceId } from "../../utils/deviceIdentity";

export const KioskAuthentication: React.FC = () => {
    const [message, setMessage] = useState("");

    const handleGenerateDeviceId = async () => {
        if (!window.confirm("Are you sure you want to generate a new auth code?")) {
            return;
        }

        const newDeviceId = generateKioskDeviceId();

        try {
            await navigator.clipboard.writeText(newDeviceId);
            setMessage(`Kiosk device code (copied): ${newDeviceId}`);
        } catch (error) {
            setMessage(`Kiosk device code: ${newDeviceId}`);
        }
    };

    return (
        <div className="kiosk-authentication-page">
            <button type="button" onClick={handleGenerateDeviceId}>
                Generate Auth Code
            </button>

            <Snackbar
                open={message !== ""}
                message={message}
                autoHideDuration={10000}
                onClose={() => setMessage("")}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            />
        </div>
    );
};

require("./styles.scss");
